export default __webpack_public_path__ + "static/media/upper.eac21723.png";